













































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentDescartarRepasse extends Vue {
  loadDescartarRepasses: boolean = false

  get modalDescartarRepasse() { return this.getFinanceiroStore.modal.descartarRepasses }
  set modaldescartarRepasse(value: boolean) { this.getFinanceiroStore.setModal({ name: 'descartarRepasses', value }) }

  get loadingDescartarRepasses() { return this.loadDescartarRepasses }
  set loadingDescartarRepasses(value: boolean) { this.loadDescartarRepasses = value }

  async descartarRepasses() {
    this.loadingDescartarRepasses = true
    const response: any = await this.getFinanceiroStore.descartarRepasses()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Repasses descartados com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getFinanceiroStore.getGeracaoRepasseAll()
      this.modaldescartarRepasse = false
      this.getFinanceiroStore.setModal({ name: 'validacaoEGeracaoRepasse', value: false })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao descartar os repasses.', icon: 'warning', color: '#C62828' })
    }
    this.loadingDescartarRepasses = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
